import removeQueryParams from './remove-query-params';

export { removeQueryParams };

export default removeQueryParams;
